/**
 * P-01: whether the first-login photo offer has been answered **in this
 * session**.
 *
 * Deliberately not in IndexedDB and deliberately not on the server. « Plus
 * tard » is a real answer for the shift a worker is about to start and a bad
 * answer forever: the offer comes back at the next login, and keeps coming
 * back until a photo exists. A persisted flag would turn one tap into a
 * permanent opt-out nobody chose.
 *
 * One flag covers both ways out of the screen. Skipping sets it because the
 * worker said no for now; **succeeding** sets it because the auth slice's
 * `photoUpdatedAt` is a login-time snapshot that stays `null` until the next
 * `/auth/me`, and without this the guard would bounce the worker straight
 * back to the screen they just satisfied. `getMe` refetches on the `Session`
 * invalidation either way, so W7 shows the new photo immediately.
 */
import { createSlice } from '@reduxjs/toolkit';

export interface PhotoPromptState {
  readonly dismissed: boolean;
}

const initialState: PhotoPromptState = { dismissed: false };

export const photoPromptSlice = createSlice({
  name: 'photoPrompt',
  initialState,
  reducers: {
    /** « Plus tard », or a photo that actually attached. */
    photoPromptDismissed: (state) => {
      state.dismissed = true;
    },
  },
});

export const { photoPromptDismissed } = photoPromptSlice.actions;
export const photoPromptReducer = photoPromptSlice.reducer;

export const selectPhotoPromptDismissed = (state: { photoPrompt: PhotoPromptState }): boolean =>
  state.photoPrompt.dismissed;
